export const fieldDetailsAcceptedType = {
  fieldProperties: ["SELECTION", "MULTI_SELECTION", "DATE_SELECTION"],
  triggers: ["TEXT","NUMBER", "SELECTION", "MULTI_SELECTION", "DATE_SELECTION"],
};
